import { TerminationCode, TerminationCodes } from '@app/constants/termination-codes';
import { ColumnTypeOption } from '../interfaces';

/**
 * Related labels are every word in the description
 */
function makeRelatedLabels(str: string): string[] {
    // we are removing "/ " from the string
    const strWithoutSlash = str.replace(/\/\s/g, '');

    return strWithoutSlash.split(' ');
}

const terminationCodeOptions: ColumnTypeOption[] = [];

for (const code in TerminationCodes) {
    const relatedLabels = [code, ...makeRelatedLabels(TerminationCodes[code as TerminationCode])];

    const option = {
        value: code,
        label: `(${code}) ${TerminationCodes[code as TerminationCode]}`,
        translatableLabel: `import.TERMINATION_CODES.${code}`,
        relatedLabels,
    };

    terminationCodeOptions.push(option);
}

/**
 * Ex:
 * {
 *   value: 'A00'
 *   label: 'A00 Shortage of work / End of Contract or Season'
 *   translatableLabel: 'import.TERMINATION_CODES.A00'
 *   relatedLabels: ['A00', 'Shortage', 'of', 'work', 'End', 'of', 'Contract', 'or', 'Season']
 * }
 */
export { terminationCodeOptions };
